import { getAuthHeaders, tempMeeApi } from '~/services/api';

const FEEDBACK_PATH = '/feedback/tempmee';

/**
 * Sends the NPS screen's optional free-text answer to the monolith. This stays
 * on the monolith whichever backend holds the score (GOTU-16475).
 */
export const submitFreeTextFeedback = async (message: string): Promise<void> => {
  const headers = await getAuthHeaders();
  await tempMeeApi.post(FEEDBACK_PATH, { message }, { headers });
};
